
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import { Button } from "nq-component";
import FormFactory from "../../../../components/FormFactory";
import BaseFormPage from "../../../../base/BaseFormPage";
import ModalContentFormPresenter from "./ModalContentFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import { _getYearOptions, _parseDateRangeToUTC } from "../../helper/dateHelper";
import { DatePicker } from "antd";
class ModalContentFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
    this.presenter = new ModalContentFormPresenter(
        this,
        getObjectUseCase(),
        upsertUseCase()
      );
  }

  getCollectionName() {
    return "payroll_details";
  }

  render() {
    const { payrollTypes, payItems, setups, query } = this.props.panelState;
    const { object, isLoading } = this.state;
    const { RangePicker } = DatePicker;

    console.log("object++", object);
    const collection = this.getCollectionName();
    const schema = this.getSchema(collection);

    const notTwentypercent = payrollTypes?.value?.name === "Special Payroll" && payItems?.value?.name !== "20% Monthly Premium"

    return (
      <>
        <FloatingForm width="40%">
          <CardView>
            <div className="row p-2">
              <h5 className="text-left mb-3"> Please input necessary details! </h5>
              <div className="mb-2 col-12">
                <FormFactory
                    className="col-lg-12 p-1 mt-2"
                    uppercase
                    schema={schema}
                    object={object}
                    onChange={this.onChange.bind(this)}
                    excludeFields={Object.keys(schema.fields || {}).filter((key) => {
                      if (key === "payrollCode") {
                        return false;
                      }
                      if (setups?.category === "AP" && key === "percentage") {
                        return false;
                      }
                      return true;
                    })}
                />
              </div>

              <p className="mt-2 m-0 ms-1" style={{ fontSize: "14px" }}>Period Covered</p>
              {payItems?.value.name !== "20% Monthly Premium" && (
                <div className="col-lg-12 p-1 mt-2">
                  <RangePicker
                    style={{ width: "calc(100% - 24px)", margin: "0 12px", boxSizing: "border-box" }}
                    onChange={(date) => this.presenter._onChangeDate(date)}
                    disabled={!!object?.year}
                    className="custom-range-picker border p-2 fw-semibold"
                  />
                </div>
              )}
              {(payItems?.value.name === "20% Monthly Premium" || notTwentypercent) && (
                <>
                  {notTwentypercent && (
                    <label className="form-label mt-2 ms-2 me-2">or</label>
                  )}
                  <FormFactory
                    className="col-lg-12 p-1 mt-2"
                    uppercase
                    schema={{
                      ...schema,
                      fields: {
                        ...schema.fields,
                        year: {
                          ...schema.fields?.year,
                          options: _getYearOptions().map((year) => ({
                            label: year,
                            value: year,
                          })),
                          disabled: !!object?.datePicked,
                        },
                        monthTo: {
                          ...schema.fields?.monthTo,
                          disabled: !object?.monthFrom,
                        },
                      },
                    }}
                    object={object}
                    onChange={this.onChange.bind(this)}
                    excludeFields={Object.keys(schema.fields).filter((key) => {
                      if (payItems?.value.name === "20% Monthly Premium") {
                        return !["monthFrom", "monthTo", "year"].includes(key);
                      }
                      if (notTwentypercent) {
                        return key !== "year";
                      }
                      return true;
                    })}
                    />
                </>
              )}

              <div className="w-100 d-flex justify-content-end gap-2 pe-3 pb-3 mt-4">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.onClose()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  disabled={isLoading}
                  onClick={() => this.props.onGenerate(object)}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Loading...
                    </>
                  ) : (
                    "Continue"
                  )}
                </Button>
              </div>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}

export default ModalContentFormPage;
